import {
  CustomSelect,
  TextAppearance,
  TextCustom,
} from '@vw-marketing/us-components';
import React from 'react';
import { OptionsProps } from '../../typings/general';
import { StyledErrorMessage, StyledSelect } from './styled';

interface SelectFieldProps {
  label: string;
  value: string;
  options: OptionsProps[];
  appearance?: 'error' | 'success' | 'default';
  message?: string;
  disabled: boolean;
  onChange: (value: string) => void;
}

export const SelectField = ({
  label,
  value,
  options,
  appearance,
  message,
  disabled,
  onChange,
}: SelectFieldProps) => {
  return (
    <StyledSelect>
      <CustomSelect
        label={label}
        value={value}
        aria-label={label}
        onChange={(event) => onChange(event.currentTarget.value)}
        appearance={appearance}
        required
        isFloating
        disabled={disabled}
      >
        <option value="" disabled>
          {label}
        </option>
        {options.map((option, index) => (
          <option value={option.value} key={`${option.value}-${index}`}>
            {option.label}
          </option>
        ))}
      </CustomSelect>
      {message && (
        <StyledErrorMessage>
          <TextCustom appearance={TextAppearance.copy100}>{message}</TextCustom>
        </StyledErrorMessage>
      )}
    </StyledSelect>
  );
};
